import { ReactElement, useEffect, useState } from "react";
import { Table, TableBody, TableCell,  TableHead, TableRow } from "@mui/material";
import { formatTimeWithSeconds } from "../../../system/utils";
import StyledTableRow from "../../../components/styledTableRow";
import { IColumn, ISample } from "../../../types";
import TableContainer  from "../../../components/tableContainer";

const columns: IColumn[] = [
  {
    id: "sample",
    label: "Sample ID",
    minWidth: 200
  },
  {
    id: "measured",
    label: "Measured Time",
    minWidth: 100,
    align: "center",
    format: value => formatTimeWithSeconds(value)
  },
  {
    id: "temp",
    label: "Temp",
    minWidth: 100,
    align: "right"
  },
  {
    id: "predictedTemp",
    label: "Predicted Temp",
    minWidth: 100,
    align: "right",
  },
  {
    id: "o2_ppm",
    label: "O2 PPM",
    minWidth: 100,
    align: "right",
  },
  {
    id: "avg_c",
    label: "%C",
    minWidth: 100,
    align: "right",
  }
];

interface ITemperature {
  sample: string;
  measured: number | null;
  temp: number | null;
  predictedTemp: number | null;
  o2_ppm: number | null;
  avg_c: number | null;
}

interface IProps {
  data: ISample[];
}

const TemperaturePanel = ({ data }: IProps): ReactElement => {
  const [ rows, setRows ] = useState<ITemperature[]>([]);

  useEffect(() => {

    const result: ITemperature[] = [];

    data.forEach(r => {

      const temp = r.items.find(x => x.name === "Temp");
      const o2_ppm = r.items.find(x => x.name === "O2");
      const avg_c = r.items.find(x => x.name === "%C");


      result.push({
        sample: r.sampleType.code,
        measured: r.sampleDatetime,
        temp: temp ? temp.value : null,
        predictedTemp: null,
        o2_ppm: o2_ppm ? o2_ppm.value : null,
        avg_c: avg_c ? avg_c.value : null
      });

    });

    setRows(result);
  }, data);

  // const createSortHandler = (property: keyof IEquipmentLife) => () => {
  //   const isAsc = orderBy === property && order === "asc";
  //   setOrder(isAsc ? "desc" : "asc");
  //   setOrderBy(property);
  // };

  return (
    <div>
      <TableContainer>
        <Table stickyHeader={true} size={"small"} >
          <TableHead>
            <TableRow>
              {columns.map((column) =>
                <TableCell
                  className="table-header"
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, width: column.minWidth }}>
                  {column.label}
                </TableCell>
              )}
              <TableCell className="table-header"/>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => {
              return (
                <StyledTableRow hover={true} role="checkbox" tabIndex={-1} key={`temp-row-${index}`}>
                  {columns.map((column: IColumn) => {
                    const value = row[column.id as keyof ITemperature];

                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format && typeof value === "number" ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                  <TableCell/>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default TemperaturePanel;
